/**
 * Version 0.170
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 *
 * 2026
 * 08-02-2026
 * - [CHANGE] images.preload() is now checking if the function exists before calling it.
 * 25-01-2026
 * 	- [CHANGE] specific_interactions.catchAndActiveURL() improved active URL detection.
 * 02-11-2025
 * - [CHANGE] specific_interactions.beforeRoute() removed thisObj.
 * 23-10-2025
 * 	- [CHANGE] Update: Comment style
 * 2019
 * 	24-05-2019
 * 	- [CHANGE] Popup can now be fixed, new variable introduced.
 * 2018
 * 	11-10-2018
 * 	- [CHANGE] Made seperate files for the specific formHandling and Window interactions.
 * 	28-05-2018
 * 	- [CHANGE] The mobile menu is now closing on .init.
 * 	25-04-2018
 * 	- [ADDED] New functionality to poll for internet connection, and notify when connection is lost.
 * 	13-03-2017
 * 	- [CHANGE] Loader now returns to 0 before loading new call.
 * 	05-02-2018
 * 	- [ADDED] Now init() has an inbuild: 'Unbind: Unnecessary listeners' function
 * 	31-01-2018
 * 	- [ADDED] New method: uploaderCallback() for specific callback on upload
 * 	- [CHANGE] form.init(int) now checks if forms must be loaded in popup or in body.
 * 2017
 * 	08-10-2017
 * 	- -[METHOD] Added: formHandeling() method for specific interaction on specific forms.
 * 	29-08-2017
 * 	- [VAR] urlParts is now url[];
 * 	- [METHOD] New Method: Router: loadPage on behalf of init from Router.
 * 	02-07-2017
 * 	- [METHOD] Added: specific_interactions.windowOrientationChange() to bind interaction to landscape or portrait mode changes.
 * 	11-04-2017
 * 	- [METHOD] Changed: specific_interactions.getURL is not in charge of 'not found' anymore.
 * 	21-03-2017
 * 	- [METHOD] Added: new methods for specific getURL t.b.v. Router Class.
 * 2016
 * 	06-12-2016
 * 	- [DATEPICKER] Added: startDatepicker onclick when date selection is needed and then check type
 * 	04-12-2016
 * 	- [ONREADY] Added: the username bindings
 * 	- [ONREADY] Added: the bodyfat calculate checkbox bindings
 * 	- [DATEPICKER] Added the datepicker interaction
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	// this.onready = function () {
	// };

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.beforeRoute = function (
		href,
		optionArray
	) {

		var type = optionArray[0];

		/**
		 * Check if next URL is an popup or page or sub
		 */
		if (type === 'popup') {

			/**
			 * Catch the variables when type is popup
			 */
			var popupFixed = optionArray[1];
			var popupDirect = optionArray[2];
			var popupTarget = optionArray[3];
			var popupData = optionArray[4];

			/**
			 * Popup: Open
			 */
			popup.open(
				popupFixed,
				popupDirect,
				popupTarget,
				popupData
			);

			/**
			 * Go on and load the next page
			 */
			router.afterRoute(
				href,
				type
			);

		} else {

			/**
			 * Do some animation with the Page Loader
			 */
			specific_interactions.loader(1, 1);

			/**
			 * Go on and load the next page
			 */
			router.afterRoute(
				href,
				'page'
			);

		}

	};

	/**
	 * Popup
	 */
	this.popup = function (openorclose, popup) {

		/**
		 * Open popup
		 */
		if (openorclose == 'open') {

			/**
			 * Get: Popup type
			 */
			popupType = $('.popup').data('go-popuptype');

			/**
			 * Trigger keypress off
			 */
			//specific_interactions.keypress('off',popuptype);

			if (
				popupType == 'media'
			) {

				var swiper = new Swiper('.js-swiper-gallery', {
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					grabCursor: true,
					spaceBetween: 10,

					// 📱 Mobile first
					slidesPerView: 1,
					centeredSlides: false,

					breakpoints: {
						768: {
							slidesPerView: 'auto',
							centeredSlides: true,
							spaceBetween: 20
						}
					}
				});

			}

		}

		/**
		 * Close popup
		 */
		if (openorclose == 'close') {

			/**
			 * Get: Popup type
			 */
			//popupType = $('.popup').data('go-popuptype');

			/**
			 * Trigger keypress off
			 */
			//specific_interactions.keypress('off',popuptype);

		}


	};

	/**
	 * Keypress
	 */
	this.keypress = function (action, type) {

		if (action == 'on') {

		}

		if (action == 'off') {

		}

	};

	this.catchKeypress = function (e, type) {

	};

	/**
	 * Router
	 */

	/**
	 * Router: get specific URL
	 */
	this.getURL = function () {

		/**
		 * Get URL parts
		 */
		url = getUrl();

		/**
		 * Route
		 */
		_returnUrl = '';
		_returnUrl = globalUrl + renderSubUrl();

		if (typeof _returnUrl !== 'undefined') {
			return _returnUrl;
		} else {
			return false;
		}

	};

	/**
	 * Router: loadPage
	 */
	this.loadPage = function (
		data,
		type
	) {

		/**
		 * Mainpage or Subpage?
		 */
		_loader = '.page-loader';

		/**
		 * Fade current page out and the new page in when loading is done
		 */
		$(_loader).stop().animate({ 'opacity': 0 }, 0, function () {

			setTimeout(function () {

				/**
				 * Set HTML
				 */
				$(_loader).html(data);

				/**
				 * Fade in Page Loader
				 */
				$(_loader).stop().animate({ 'opacity': 1 }, 200);

				/**
				 * Trigger: Resize Window
				 */
				specific_interactions_window.windowResize();

				/**
				 * Trigger: images preloader
				 */
				if (typeof images !== 'undefined' && typeof images.preload === 'function') {
					images.preload();
				}

				/**
				 * Trigger: forms init
				 */
				form.init(0);

				/**
				 * Default: init();
				 */
				init();

			}, 200);

		});

	};

	/**
	 * Catch active URL
	 */
	this.catchAndActiveURL = function () {

		/**
		 * Catch and active URL
		 */
		$('.js-nav-item').removeClass('active');

		// if (url[3] !== '') {
		// 	_url_active_main = url[3] + '/' + url[4];
		// } else {
		// if (url[3] !== '') {
		// 	_url_active_main = url[2] + '/' + url[3];
		// } else {
		// if (url[2] !== '') {
		// 	_url_active_main = url[2];
		// }
		//}

		//}
		var _url_active_main = './';
		var _url_parts = [];

		// Build URL parts array, filtering out empty segments
		for (var i = 1; i < url.length; i++) {
			if (url[i] !== '') {
				_url_parts.push(url[i]);
			}
		}

		/**
		 * Strip language code if first segment is a two-character language code
		 */
		if (_url_parts.length > 0 && _url_parts[0].length === 2) {
			_url_parts.shift(); // Remove the language code
		}

		// Try to match URLs from most specific to least specific
		for (var depth = _url_parts.length; depth > 0; depth--) {
			var _constructed_url = _url_parts.slice(0, depth).join('/');
			var $matchingElement = $('.js-nav-item[data-go-url="' + _constructed_url + '"]');

			if ($matchingElement.length > 0) {
				$matchingElement.addClass('active');
				break; // Stop at first match to avoid multiple active items
			}
		}

		// Fallback to root if no segments found
		if (_url_parts.length === 0) {
			$('.js-nav-item[data-go-url="./"]').addClass('active');
		}

	};

	/**
	 * MOBILE MENU ******************************************************************************
	 */
	this.toggleMobileMenu = function (i) {

		/**
		 * Get setting in var
		 */
		if (i === 0) {
			_mode = 'close';
		} else {
			if (isSmartphoneMenuOpen === 0) {
				_mode = 'open';
			} else {
				_mode = 'close';
			}
		}

		/**
		 * Interaction
		 */
		if (_mode === 'close') {

			/**
			* Close
			*/
			isSmartphoneMenuOpen = 0;

		} else {

			/**
			* Open
			*/
			isSmartphoneMenuOpen = 1;

		}

	};

	/**
	 * Loader
	 */
	this.loader = function (i, option) {

		switch (i) {

			/**
			* Main Loader
			*/
			default:

				switch (option) {

					default:
					case 0:

						/**
						* Hide loader
						*/
						$('.js-loader').stop().css('width', 0);

						break;

					case 1:

						/**
						* fadeIn loader, but delay on 200ms
						*/
						$('.js-loader').css('width', 0).stop().delay(200).animate({ 'width': $(window).width() }, 2000);

						break;

				}

		}

	};

	/**
	 * Notifier **********************************************************************
	 */
	this.notifier = function (
		i,
		error,
		message
	) {

		/**
		 * Set coloring
		 */
		if (error == 1) {
			_backgroundColor = notifierErrorBackgroundColor;
			_textColor = notifierErrorTextColor;
		} else {
			_backgroundColor = notifierNormalBackgroundColor;
			_textColor = notifierNormalTextColor;
		}

		/**
		 * Do something with the notifier
		 */
		switch (i) {

			default:

				/**
				 * Set notifier colors
				 */
				$('.notifier-message').html(message).css('background-color', _backgroundColor).css('color', _textColor);

				/**
				 * fadeIn notifier
				 */
				$('.notifier').fadeIn(500, function () {

					setTimeout(function () {
						$('.notifier').stop().fadeOut(400);
					}, 1500);

				});

				break;

		}

	};

	/**
	 * MODAL **********************************************************************
	 */
	this.modal = function (openorclose) {

		/**
		 * Open modal
		 */
		if (openorclose == 'open') {

		}

		/**
		 * Close modal
		 */
		if (openorclose == 'close') {

		}

	};

}).apply(specific_interactions); 
